import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import type { UserCountry } from 'types/users.types';

const useCustomerCountry = (): UserCountry | undefined => {
  const user = useGetCurrentCustomerData();
  return user?.data?.country;
};

export default useCustomerCountry;
